// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3cv0y","colMin":"styles_colMin__3yu2E","colCheckbox":"styles_colCheckbox__3tHfQ"};